import React from "react";
import { InMemoryDownload } from "../InMemoryDownload";
import { Release } from "../../models";
import { ReleaseFileList } from "./ReleaseFileList";

interface Props {
  releaseFiles: ReleaseFileList;
  release: Release;
}

export function Tr3BootloaderFileList({ releaseFiles, release }: Props) {
  return (
    <>
      <td>
        {releaseFiles.bootloaderRelease && (
          <>
            <InMemoryDownload
              displayName="Bootloader"
              fileName={`bootloader-${release.version}.bin`}
              content={releaseFiles.bootloaderRelease?.data}
            />
          </>
        )}
        {releaseFiles.bootloaderReleaseElf && (
          <>
            <br />
            <InMemoryDownload
              displayName="Bootloader (ELF)"
              fileName={`bootloader-${release.version}.elf`}
              content={releaseFiles.bootloaderReleaseElf?.data}
            />
          </>
        )}
        {releaseFiles.releaseRebootstrapper && (
          <>
            <br />
            <InMemoryDownload
              displayName="Rebootstrapper"
              fileName={`rebootstrapper-${release.version}.bin`}
              content={releaseFiles.releaseRebootstrapper?.data}
            />
          </>
        )}
        {releaseFiles.releaseRebootstrapperSfbDevKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="Rebootstrapper (SFB, Dev Keys)"
              fileName={`rebootstrapper-dev-${release.version}.sfb`}
              content={releaseFiles.releaseRebootstrapperSfbDevKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseRebootstrapperSfbProdKeys && (
          <>
            <br />
            <InMemoryDownload
              displayName="Rebootstrapper (SFB, Prod Keys)"
              fileName={`rebootstrapper-prod-${release.version}.sfb`}
              content={releaseFiles.releaseRebootstrapperSfbProdKeys?.data}
            />
          </>
        )}
        {releaseFiles.releaseRebootstrapperElf && (
          <>
            <br />
            <InMemoryDownload
              displayName="Rebootstrapper (ELF)"
              fileName={`rebootstrapper-${release.version}.elf`}
              content={releaseFiles.releaseRebootstrapperElf?.data}
            />
          </>
        )}
      </td>

      {/* No debug files for TR3 */}
      <td></td>

      {/* No translation files for TR3 */}
      <td></td>
    </>
  );
}
